'use strict'
const merge = require('webpack-merge')
const prodEnv = require('./prod.env')

module.exports = merge(prodEnv, {
  NODE_ENV: '"development"',
  BASE_API: 'http://192.168.0.152:8085'
  // BASE_API: '""'
})



// WEBPACK FOOTER //
// ./config/dev.env.js